export default {
  header: 'Vybrať špecifikáciu na načítanie',
  hint: 'Nie všetky snímače sú priradené k tomuto zariadeniu',
};
